import classes from './Tech.module.scss';

export default function Tech({ value }) {
  return <span className={classes.techItem}>{value}</span>;
}

